export default __webpack_public_path__ + "static/media/Cedora-RegularStd.6ded077c.otf";